/**
 * Candela — page scroll lock for our own overlays.
 *
 * Quick-add, the size guide and the search overlay each call update() when
 * they open or close. update() recomputes from the DOM rather than counting
 * calls, so closing one overlay while another is still open keeps the lock,
 * and a missed call can never leave the page stuck.
 *
 * The class goes on <html>, not <body>: html is the page scroller here, and
 * since it already carries overflow-x, body's overflow no longer propagates to
 * the viewport. A class of our own, so it never fights Dawn's own
 * `body.overflow-hidden`.
 */
(function () {
  var OPEN_OVERLAYS = [
    '.candela-quick-add[aria-hidden="false"]',
    '.candela-size-guide[aria-hidden="false"]',
    '.candela-directions[aria-hidden="false"]',
    '.candela-search-overlay.is-active',
  ];

  function update() {
    var open = OPEN_OVERLAYS.some(function (selector) {
      return document.querySelector(selector) !== null;
    });
    document.documentElement.classList.toggle('candela-scroll-locked', open);
  }

  window.CandelaScrollLock = { update: update };
})();
